/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import { generateCode } from './tools'
import domReady from '@wordpress/dom-ready';

domReady(() => {
    // all possible blocks in the future - querySelectorAll
    const codeGenerator = document.querySelector('.wp-block-wz-blocks-code-generator');
    const codeGeneratorText = codeGenerator.querySelector('p');
    const codeGeneratorButton = codeGenerator.querySelector('button');

    codeGeneratorButton.addEventListener('click', event => {
        event.preventDefault();

        codeGeneratorText.textContent = generateCode(codeGenerator.dataset.characters, Number(codeGenerator.dataset.length), codeGenerator.dataset.characterCase);
    });
});
